
import Vue, { PropType } from 'vue';
import { CvButton, CvLink } from '@carbon/vue';
import { AxiosError } from 'axios';

export default Vue.extend({
  components: { CvButton, CvLink },
  props: {
    isMethodSelected: {
      type: Boolean,
      required: true,
    },
    previousStepExists: {
      type: Boolean,
      required: true,
    },
    nextStepExists: {
      type: Boolean,
      required: true,
    },
    isFileValid: {
      type: Boolean,
      default: false,
    },
    isDetailLost: {
      type: Boolean,
      default: false,
    },
    isCreatePersonalizationSuccessful: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: [] as PropType<AxiosError[]>,
      default: [],
    },
    selectedMethod: {
      type: String,
      required: true,
    },
    isFileUploaded: {
      type: Boolean,
      default: false,
    },
    isAnalysisInProgress: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    isDisabled(): boolean {
      if (
        this.selectedMethod === 'Full design' ||
        this.selectedMethod === 'Full design artworks'
      ) {
        return !(
          this.nextStepExists &&
          (this.isMethodSelected || this.isFileUploaded)
        );
      }

      return !(
        this.nextStepExists &&
        (this.isMethodSelected ||
          (this.isFileValid &&
            this.isFileUploaded &&
            !this.isDetailLost &&
            !this.isAnalysisInProgress))
      );
    },
  },
});
